import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function SadFeedback({feedback}) {
    
    return (
        <div
            className='sad-face'
            style={{opacity: feedback ? '1' : '0'}}
        ></div>
    );
}

export default SadFeedback;